// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_fx","pagination__item":"_fy","pagination__dots":"_fz","pagination__current":"_fA"};